export function getReadablePhoneNumber(phoneNumber: string): string {
  return phoneNumber.replace(/^\+\d+\s*/, '')
}

export function getWhatsappNumber(phone: string): string {
  const sanitizedPhone = phone.replace(/\D+/g, '')
  return `https://wa.me/${sanitizedPhone}`
}
